import { Alert, Button, Modal, Space, Spin, Typography } from "antd";
import { useLocation } from "react-router-dom";

import { signInAgain } from "../../utils/mfa-step-up";
import LoginMfaChallenge from "../auth/LoginMfaChallenge";
import { useReauthenticate } from "./useReauthenticate";

interface ReauthenticateModalProps {
    open: boolean;
    onSuccess: () => void;
    onCancel: () => void;
}

export default function ReauthenticateModal({ open, onSuccess, onCancel }: ReauthenticateModalProps) {
    const location = useLocation();
    const { error, loading, challenge, federated, hasPasskey, handleResult } = useReauthenticate({ open, onSuccess });

    return (
        <Modal
            open={open}
            title="Confirm it's you"
            footer={null}
            onCancel={onCancel}
            destroyOnHidden
        >
            <Space direction="vertical" size="middle" style={{ width: "100%" }}>
                <Typography.Text type="secondary">
                    For your security, confirm it's you before changing sign-in methods.
                </Typography.Text>
                {federated ? (
                    <>
                        <Typography.Paragraph>Sign in again with Google or GitHub to continue</Typography.Paragraph>
                        <Button type="primary" block onClick={() => signInAgain(location.pathname)}>Sign in again</Button>
                    </>
                ) : challenge ? (
                    <LoginMfaChallenge
                        key={challenge.transactionId}
                        challenge={challenge}
                        onResult={handleResult}
                        onCancel={onCancel}
                        preferPasskey={hasPasskey}
                    />
                ) : (
                    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
                        {error && <Alert type="error" showIcon message={error} />}
                        {loading && <Spin />}
                    </Space>
                )}
                {!federated && !challenge && (
                    <Alert
                        type="info"
                        showIcon
                        message="This confirmation is only needed when it has been a while since you signed in."
                    />
                )}
            </Space>
        </Modal>
    );
}
